<template>
    <div class="pagination">
        <nav aria-label="Pagination" v-if="lastPage > 1">
            <ul class="pagination justify-content-end mb-0">
                <!-- Pagination Elements -->
                <template v-for="(item, index) in paginationItems" :key="index">
                    <!-- "Three Dots" Separator -->
                    <li v-if="item.type === 'dots'" class="page-item disabled" aria-disabled="true">
                        <span class="">...</span>
                    </li>

                    <!-- Page Number -->
                    <li v-else class="page-item" :class="{ 'active': item.page === currentPage }">
                        <template v-if="item.page === currentPage">
                            <span class="">{{ item.page }}</span>
                        </template>
                        <template v-else>
                            <a class="page-link" href="#" @click.prevent="$emit('page-click', item.page)">{{ item.page }}</a>
                        </template>
                    </li>
                </template>
            </ul>
        </nav>
    </div>
</template>

<script setup>
import { usePagination } from '@/composables/usePagination';

const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  lastPage: {
    type: Number,
    required: true
  },
  onEachSide: {
    type: Number,
    default: 1
  }
});

const emit = defineEmits(['page-click']);

const { paginationItems } = usePagination(props, emit);
</script>

<style scoped>

</style>
